import React from "react";

function formatPercent(value) {
  return `${Math.round((Number(value) || 0) * 100)}%`;
}

export default function DonutChart({
  correctCount = 0,
  incorrectCount = 0,
  size = 176,
}) {
  const safeCorrect = Math.max(0, Number(correctCount) || 0);
  const safeIncorrect = Math.max(0, Number(incorrectCount) || 0);
  const total = safeCorrect + safeIncorrect;
  const correctRatio = total > 0 ? safeCorrect / total : 0;
  const angle = Math.round(correctRatio * 360);
  const inset = Math.max(16, Math.round(size * 0.2));

  const background =
    total > 0
      ? `conic-gradient(#22c55e 0deg ${angle}deg, #ef4444 ${angle}deg 360deg)`
      : "#E5E7EB";

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="relative" style={{ width: size, height: size }}>
        <div
          className="h-full w-full rounded-full"
          style={{ background }}
        />
        <div
          className="absolute rounded-full bg-white shadow-inner"
          style={{ inset }}
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          {total === 0 ? (
            <>
              <div className="text-lg font-semibold text-gray-900">Keine</div>
              <div className="text-xs uppercase tracking-wide text-gray-500">
                Nutzung
              </div>
            </>
          ) : (
            <>
              <div className="text-2xl font-semibold text-gray-900">
                {formatPercent(correctRatio)}
              </div>
              <div className="text-xs uppercase tracking-wide text-gray-500">
                richtig
              </div>
            </>
          )}
        </div>
      </div>

      <div className="grid w-full max-w-[260px] grid-cols-2 gap-3 text-sm">
        <div className="rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-center">
          <div className="font-semibold text-green-700">{safeCorrect}</div>
          <div className="mt-1 text-xs uppercase tracking-wide text-green-700">Richtig</div>
        </div>
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-center">
          <div className="font-semibold text-red-700">{safeIncorrect}</div>
          <div className="mt-1 text-xs uppercase tracking-wide text-red-700">Falsch</div>
        </div>
      </div>
    </div>
  );
}
